import textBalancer from 'text-balancer';

export default class RotateStatements {
  constructor(options) {
    if (window.railsEnv == 'test') {
      return;
    }

    const defaults = {
      startDelay: 0,
      statements: null,
      containerElement: null,
      textElement: null,
      animateWidth: true,
      addActiveClassAsText: false,
    };
    this.currentStatement = 0;
    this.settings = $.extend({}, defaults, options);
    this.statement_count = this.settings.statements.length;
    this.startingClassNames = $(this.settings.textElement).attr('class');
    this.autoRotateStatements();
  }

  autoRotateStatements = () => {
    clearInterval(this.interval);
    this.interval = setInterval(this.showStatement, this.settings.speed);
  };

  showStatement = () => {
    this.currentStatement += 1;
    if (this.currentStatement > this.statement_count - 1) {
      this.currentStatement = 0;
    }
    $(this.settings.containerElement).addClass('animating');

    setTimeout(() => {
      if (this.settings.addActiveClassAsText) {
        $(this.settings.textElement)
          .removeClass()
          .addClass(this.startingClassNames)
          .addClass(
            this.settings.statements[this.currentStatement]
              .toLowerCase()
              .replace(' ', '-')
          );
      }
      $(this.settings.textElement).text(
        this.settings.statements[this.currentStatement]
      );
      textBalancer.balanceText();
      if (this.settings.animateWidth) {
        $(this.settings.containerElement).width(
          $(this.settings.textElement).width()
        );
      }
    }, this.settings.speed / 8);

    setTimeout(() => {
      $(this.settings.containerElement).removeClass('animating');
    }, this.settings.speed / 4);
  };

  pause = () => {
    window.clearInterval(this.interval);
  };
}
